import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import PageSection from './PageSection';
import { addUtils } from './class-name-helpers';

export const ICON_PATTERN_IMAGE = 'https://images.ctfassets.net/gtqjh9j40j4m/76tGccp0W9NsYXobuAYSeP/687095a3f637c2854e5c8d6f63cc6094/dossier-background-1.svg';

const IconBannerPageSection = ({ children, ...rest }) => {
  const className = clsx(addUtils(rest).utilClassNames, 'ss_page-section--pattern');

  return (
    <PageSection
      bgPrimary
      dark
      backgroundImage={{ url: ICON_PATTERN_IMAGE }}
      className={className}
      container={false}
    >
      {children}
    </PageSection>
  );
};

IconBannerPageSection.propTypes = {
  children: PropTypes.node.isRequired,
};

export default IconBannerPageSection;
